'use strict';
var tealiumEnable = require('int_tealium_sfra/tealiumEnable');
var utils = require('./utils');

$(document).ready(function () {
    $(document).on('click', '#cancelOrderBtn', function (e) {
        $(this).attr('disabled', 'true');
        let dataURL = $(this).data('url');
        var orderId = $('#cancelOrderBtn').data('orderid');
        $.ajax({
            url: dataURL,
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                let $orderHeaderMsg = $('.order-thank-you-msg');
                $orderHeaderMsg.html($orderHeaderMsg.data('cancelmsg'));
                $('.edit-cancel-order').fadeOut('slow');
                utils.showConfirmToast(data.cancelMsg);
                tealiumEnable.getAnalyticsData('CancelOrderSuccess', orderId);
                utils.closeModal($('#cancelOrderModal'), e);
            },
            error: function (data) {
                if (data && data.responseJSON && data.responseJSON.errorMsg) {
                    $('#cancelOrderBtn').removeAttr('disabled');
                    utils.showErrorToast(data.responseJSON.errorMsg);
                    tealiumEnable.getAnalyticsData('serverError', data.responseJSON.errorCode);
                }
                utils.closeModal($('#cancelOrderModal'), e);
            }
        });
    });

    $(document).on('click', '#editOrderBtn', function () {
        $(this).attr('disabled', 'true');
        let dataURL = $(this).data('url');
        var orderId = $('#editOrderBtn').data('orderid');
        $.ajax({
            url: dataURL,
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                if (data && data.redirectUrl) {
                    $('#editOrderModal').modal('hide');
                    window.location.href = data.redirectUrl;
                }
                tealiumEnable.getAnalyticsData('EditOrderSuccess', orderId);
            },
            error: function (data) {
                $('#editOrderModal').modal('hide');
                if (data && data.responseJSON && data.responseJSON.errorMsg) {
                    $('#editOrderBtn').removeAttr('disabled');
                    utils.showErrorToast(data.responseJSON.errorMsg);
                    tealiumEnable.getAnalyticsData('serverError', data.responseJSON.errorCode);
                }
            }
        });
    });

    $(document).on('click', '.dismiss-alert', function () {
        $(this).closest('.alert').remove();
    });

    $(document).on('click', '#editOrder', function () {
        var orderId = $('#editOrder').data('orderid');
        tealiumEnable.getAnalyticsData('editOrderOnLoad', orderId);
    });

    $(document).on('click', '.cancel-placed-order', function () {
        var orderId = $('.cancel-placed-order a').data('orderid');
        tealiumEnable.getAnalyticsData('CancelOrderOnLoad', orderId);
    });
});
